import { DrawerDesignTokens } from '@primeuix/themes/types/drawer';

export const DRAWER_STYLES: DrawerDesignTokens = {
  // Drawers appended to <body> (PrimeNG default) must not be visible on non-desktop screens
  // To be removed on PrimeNG v21 update
  css: `
    @media (max-width: 1023px) {
      body > .p-drawer,
      body > .p-drawer-mask {
        display: none !important;
      }
    }
  `,
};
